module.exports = __webpack_public_path__ + "static/media/Author.b62ca4b4.jpg";